const AUTH_SCOPES = [
    "cloud-contact-center:pod_conv",
    "cloud-contact-center-digital:read",
    "cloud-contact-center-digital:write",
    "webex-squared:kms_write",
    "webex-squared:kms_bind",
    "webex-squared:kms_read",
    "webexsquare:get_conversation",
    "Identity:SCIM",
    "spark:all",
    "spark:mcp",
    "spark:people_read",
    "spark:kms",
    "cjp:config_read",
    "cjp:config_write",
    "spark:messages_write",
    "cjp:user",
    "spark:webrtc_calling",
    "spark:calls_read",
    "spark:calls_write",
    "spark:telephony_config_read",
    "spark:telephony_config_write",
    "meeting:admin_recordings_read",
    "meeting:admin_transcripts_read",
    "meeting:admin_schedule_write",
    "meeting:admin_schedule_read",
    "meeting:summaries_read",
    "meeting:participants_write"
];
export const AUTH_SCOPE = AUTH_SCOPES.join(" ");
export const LOGIN_METRICS = {
    CORRELATE_PRELOGIN_METRICS: "webex_login_correlate_prelogin_metrics",
    FAILED: "webex_login_failed",
    STATION_LOGIN_INITIATED: "station_login_initiated",
    REDIRECT_TO_LOGIN: "webex_login_redirect_to_login_url",
    REDIRECT_WITH_STATE: "webex_login_redirect_with_state",
    STATION_LOGIN_FAILED: "station_login_failed",
    STATION_LOGIN_SUCCESS: "station_login_success"
};
export { LOGIN_JOURNEY } from "@agentx/agentx-services";
export const TIME_TO_LOAD_LOGIN_UI = "time-to-load-login-ui";
